var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{staticClass:"pt-1 text-right cursor-pointer",attrs:{"cols":!!_vm.cols ? _vm.cols : 5},on:{"click":_vm.goToBasket}},[_c('v-icon',{staticClass:"login-icon",attrs:{"color":"#ffffff"}},[_vm._v("mdi-cart-outline")]),_c('span',{staticClass:"login-text"},[_vm._v(_vm._s(_vm.basketValue.toFixed(2))+" "+_vm._s(_vm.currencyText))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }